"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconAccessorialsPublish = function SvgIconAccessorialsPublish(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    fill: "currentColor",
    fillRule: "evenodd",
    viewBox: "0 0 48 48",
    "aria-label": "accessorials publish icon"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Accessorials Publish Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M35.461 4c-4.63 0-9.326 2.97-12.14 7.62H9.523c-2.615 0-4.825 3.78-4.825 8.255 0 4.474 2.21 8.254 4.825 8.254h1.892l7.538 13.532C19.788 43.16 21.294 44 22.84 44a4.3 4.3 0 002.267-.65c2.138-1.321 2.858-4.227 1.605-6.478l-4.87-8.744h1.48c2.814 4.65 7.51 7.62 12.14 7.62 4.398 0 7.842-6.972 7.842-15.875C43.303 10.971 39.86 4 35.461 4zm0 29.21c-1.776 0-3.691-2.625-4.704-6.84 2.693-.87 4.759-3.402 4.759-6.495 0-3.094-2.021-5.8-4.704-6.71 1.025-4.09 2.905-6.625 4.65-6.625 2.567 0 5.429 5.476 5.429 13.335 0 7.858-2.862 13.334-5.43 13.334z"
  }));
};

var _default = SvgIconAccessorialsPublish;
exports.default = _default;